import React, { useEffect, useMemo, useRef, useState } from "react";
import type { Dispatch} from "umi";
import { connect, useIntl } from "umi";
import { useLocalStorageState } from 'ahooks-v2';
import { Badge, Button, Dropdown, Tooltip } from "antd";
import { ApiOutlined, CodeOutlined, MessageOutlined } from "@ant-design/icons";

import type { InquiryState } from "@/models/inquiry";
import type { InquiryOnlineStatus } from "@/pages/Inquiry/data";
import InquiryList from "../InquiryList";
import InquiryHeader from "../InquiryHeader";
import InquirySender from "../InquirySender";
import DraggableModal from "../../DraggableModal";
import InquiryCountdown from "../InquiryCountdown";
import InquiryRecordList from "../InquiryRecordList";
import styles from './index.less';
import console_default from '@/assets/images/inquiry/console_default.png'
import { useInquirySlot } from "@/providers/SlotProvider";

export interface InquiryProps {
  inquiry: InquiryState;
  dispatch: Dispatch;
};

const InquiryDropdown: React.FC<InquiryProps> = ({
  inquiry,
  dispatch
}) => {
  // 国际化
  const intl = useIntl();
  const c = window.$tc('', intl.formatMessage);
  const t = window.$tc('component.Inquiry.InquiryDropdown', intl.formatMessage);

  const drawerContainerRef = useRef<HTMLDivElement>(null);

  const [unread, setUnread] = useState<number>(0);
  const [consoleVisible, setConsoleVisible] = useState<boolean>(false);
  const [inquiryOnlineStatus, setInquiryOnlineStatus] = useLocalStorageState<InquiryOnlineStatus>('inquiryOnlineStatus', 'ONLINE');

  // const dropdownOverlay = (
  //   <Menu>
  //     <Menu.Item key="online" onClick={() => setInquiryOnlineStatus(inquiryOnlineStatus === 'ONLINE' ? 'OFFLINE' : 'ONLINE')}>
  //       <ApiOutlined/> {t('t0', '设为')}{inquiryOnlineStatus === 'ONLINE' ? t('t1', '离线') : t('t2', '在线')}
  //     </Menu.Item>
  //     <Menu.Divider />
  //     <Menu.Item key="console" onClick={() => setConsoleVisible(true)}>
  //       <CodeOutlined/> {t('t3', '咨询服务台')}
  //     </Menu.Item>
  //   </Menu>
  // );
  const dropdownOverlay = {
    items: [
      {
        key: 'online',
        label: (
          <Button type="text" style={{ padding: 0 }} onClick={() => setInquiryOnlineStatus(inquiryOnlineStatus === 'ONLINE' ? 'OFFLINE' : 'ONLINE')}>
            <ApiOutlined/> {t('t0', '设为')}{inquiryOnlineStatus === 'ONLINE' ? t('t1', '离线') : t('t2', '在线')}
          </Button>
        ),
      },
      {
        key: 'console',
        label: (
          <Button type="text" style={{ padding: 0 }} onClick={() => setConsoleVisible(true)}>
            <CodeOutlined/> {t('t3', '咨询服务台')}
          </Button>
        ),
      }
    ]
  };

  useEffect(() => {
    if (inquiry.inquiryModalVisible) {
      setConsoleVisible(true);
    }
  }, [inquiry.inquiryModalVisible]);
  useMemo(() => {
    if (inquiry.inquiryList.length) {
      let count = 0;
      inquiry.inquiryList.map((item) => {
        count += (item.imMessageBox?.unread || 0);
      })
      setUnread(count);
    } else {
      setUnread(0);
    }
  }, [inquiry.inquiryList]);

  // 设置弹窗
  let InquiryDropdownTooltip = false
  const [Defaultvisible, setDefaultvisible] = useState<boolean>(InquiryDropdownTooltip)
  // localStorage.removeItem('RightContentVisible')
  // 判断本地里有没有存值 如果有的话就代表已经弹过弹窗  无需再提示 否则就提示并把值存到本地
  useMemo(()=>{
    if (localStorage.getItem('RightContentVisible')) {
      InquiryDropdownTooltip = false
    } else{
      setTimeout(() => {
        setDefaultvisible(true)
        setTimeout(() => {
          setDefaultvisible(false)
        }, 5000);
      }, 12000)
    }
  }, []);
  const inquiryText= <span>{t('t4', '查看客户在线咨询消息，及时回复客户')}</span>
  const color = 'blue';

  //设置提示框的样式
  const object={
    width:'200px',
    height:'auto',
    borderRadius:'6px',
    fontSize:'16px',
    marginTop:'-1px'
  }
  const [, updateInquirySlot] = useInquirySlot()
  useEffect(() => {
    updateInquirySlot({
      inquiryOnlineStatus,
      setConsoleVisible,
      setInquiryOnlineStatus,
      unread,
    })
  }, [updateInquirySlot, inquiryOnlineStatus, setInquiryOnlineStatus, unread])
  return (
    <>
      {/* <Button onClick={() => dispatch({ type: 'inquiry/initInquiry' })}>{t('t5', '连接')}socket</Button> */}
      <Dropdown menu={dropdownOverlay}>
        <Badge size="small" count={inquiryOnlineStatus === 'ONLINE' ? unread : undefined}>
          <Tooltip placement="bottom" title={inquiryText} color={color} open={Defaultvisible} overlayInnerStyle={object}>
            <MessageOutlined className={styles.messageIcon} style={{top:0}} />
          </Tooltip>
        </Badge>
      </Dropdown>

      <DraggableModal
        title={t('t6', "咨询服务台")}
        width="1100px"
        bodyStyle={{ height: 620, padding: 0 }}
        footer={false}
        visible={consoleVisible}
        onCancel={() => {
          dispatch({ type: 'inquiry/onInquirySiderListClick', payload: undefined })
          setConsoleVisible(false);
        }}
      >
        <div ref={drawerContainerRef} className={styles.inquiryContainer}>
          <InquiryList />
          <div className={styles.rightContainer}>
            {
              (inquiry.currentInquiry && inquiry.imEndpoint)
                ? <>
                    <InquiryHeader drawerContainerRef={drawerContainerRef} />
                    <InquiryCountdown />
                    <InquiryRecordList />
                    <InquirySender />
                  </>
                : <div className={styles.placeholder}>
                    <img src={console_default} />
                  </div>
            }
          </div>
        </div>
      </DraggableModal>
    </>
  )
};

export const mapToInquiryProps = ({ inquiry }: { inquiry: InquiryState }) => {
  return {
    inquiry
  }
}

export default connect(mapToInquiryProps)(InquiryDropdown);
